import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { filter, take } from 'rxjs/operators';
import { Roles } from '@toro/common/shared/models/roles/roles.enum';
import { Router } from '@angular/router';

@Injectable()
export class TradingViewGuard implements CanActivate {

    private currentUser: any = null;

    constructor(
        private router: Router,
        private store: Store<AppState>,
    ) {
        this.store.select((authStore) => authStore.authentication.currentUser)
            .pipe(
                filter((currentUser) => currentUser && currentUser.cblc),
                take(1)
            )
            .subscribe((currentUser) => this.currentUser = currentUser);
    }

    public canActivate() {
        let canActivate = this.currentUser && this.currentUser.role === Roles.Activated;
        if(!canActivate){
            this.router.navigateByUrl('/explore-o-mercado');
            return false;
        }
        return true;
    }
}
